import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  BusinessStatsListResponseDto,
  FilterBusinessStatsDto,
} from '../molecules/business-stats/business-stats.types';
import {
  BusinessStatsAggregateResponseDto,
  FilterStatsAggregateDto,
} from '../molecules/admin-stats-aggregate/admin-stats-aggregate.types';

@Injectable({
  providedIn: 'root',
})
export class AdminBusinessStatsService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.shout_api.url;

  list(filter: FilterBusinessStatsDto): Observable<BusinessStatsListResponseDto> {
    return this.http.post<BusinessStatsListResponseDto>(`${this.api}/business-stats/admin/list`, filter);
  }

  aggregate(filter: FilterStatsAggregateDto): Observable<BusinessStatsAggregateResponseDto> {
    return this.http.post<BusinessStatsAggregateResponseDto>(
      `${this.api}/business-stats/admin/aggregate`,
      filter,
    );
  }
}
